export class ParamsCopySchedule {
  iBusinessUnitId: number;
  dateTimeCopyFromStart: string;
  dateTimeCopyFromEnd: string;
  dateTimeCopyToStart: Date;
  listUserDepartmentAccess: Array<number>;
}
